import React from "react";

const MobileCleanerRouteBar = ({
  selectedDate,
  onDateChange,
  route,
  plan,
  loading,
}) => {
  const routeLabel = route
    ? `${route.code} – ${route.name}`
    : "Nincs route erre a napra";

  return (
    <div className="absolute top-0 left-0 right-0 z-30 bg-slate-900/95 border-b border-slate-700 px-3 py-2 flex flex-col gap-1.5">
      <div className="flex items-center gap-2">
        <label className="text-[10px] uppercase tracking-wide text-slate-400 shrink-0">
          Datum
        </label>
        <input
          type="date"
          value={selectedDate}
          onChange={(e) => onDateChange(e.target.value)}
          className="flex-1 min-w-0 text-sm bg-slate-800 border border-slate-600 rounded px-2 py-1 text-slate-100"
        />
      </div>
      <div className="text-xs text-slate-300 truncate">
        {loading ? "Betoltes..." : routeLabel}
      </div>
      {plan?.scheduled_time && (
        <div className="text-[10px] text-slate-500">
          Kezdes: {plan.scheduled_time}
        </div>
      )}
    </div>
  );
};

export default MobileCleanerRouteBar;
